<template>
  <div class="row">
    <div class="col-xs-12">
      <div class="slider" style="height: 120px;">
        <a v-for="game in games" :key="game.id" class="slider__item" style="min-width: 120px;"
          @click="launchGame({ provider: game.provider, gameId: game.gameCode })">
          <img :src="game.imageUrl" class="slider__image">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ambApi from '../api/amb';

export default {
  name: 'AmbGameList',
  props: [
    'userId',
  ],
  data: () => ({
    games: [],
  }),
  methods: {
    loadData() {
      ambApi.getGames(({ data }) => {
        console.log('data', data);
        const pgsoft = data.data.filter((game) => game.provider === 'pgsoft')
        const display = [];
        for (let i = 0; i < 30; i += 1) {
          display.push(pgsoft[i]);
        }
        this.games = [...display];
      });
    },
    async launchGame(data) {
      this.launchingOn = data.gameId;
      this.loading = true;
      await ambApi.launchGame((response) => {
        const res = response.data;
        window.location.href = res.data.url
      }, data, (e) => {
        this.$swal({
          title: 'ERROR',
          text: e.response ? e.response.data.message : e.message,
          type: 'error',
          showCancelButton: true,
          confirmButtonColor: '#ed5565',
          // cancelButtonColor: '#ed5565',
          showCancelButton: false,
          confirmButtonText: this.$t('messages.close'),
        })
      });
      const isMobile = this.detectMoblie();

    },
    detectMoblie() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];
      return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
      });
    },
  },
  mounted() {
    this.loadData();
  },
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/admin/components/AmbSmallGameList.vue